.section {
  border-bottom: 1px solid rgba(8, 18, 12, 0.12);
  padding-bottom: var(--token-space-md);
  margin-bottom: 0;
}

/* Match the Number-modeling + Currency section headings so the four
 * top-level sections (modeling, currency, expanded form, odd/even)
 * all read at the same scale. */
.section h2 {
  font-family: var(--token-font-display);
  margin: 0 0 var(--token-space-md);
  font-size: 33px;
  color: var(--token-text-primary);
}

.expandedRow {
  display: flex;
  flex-wrap: nowrap;
  gap: var(--token-space-md);
  align-items: flex-end;
}

.expandedItem {
  display: inline-flex;
  align-items: center;
  gap: var(--token-space-md);
}

.plus {
  font-family: var(--token-font-display);
  font-size: 36px;
  font-weight: 700;
}
